var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"markingsContainer",staticClass:"markings-container"},[_c('canvas',_vm._b({ref:"pdfCanvas"},'canvas',_vm.canvasAttrs,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }